
// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function($) {
    // var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
	var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
    $('a[href^="#"]').click(function(){
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        if ( target.length > 0 ) {
            var position = target.offset().top - headerHeight;
            $("html, body").animate({scrollTop:position}, 550, "swing");
            return false;
        }
    });
})


// ヘッダーの固定エフェクト // Fixed header effect
jQuery(function($) {
	var $header = $('header');
	$(window).scroll(function() {
		if ($(window).scrollTop() > 50) {
			$header.addClass('fixed');
		} else {
			$header.removeClass('fixed');
		}
	});
});



// レスポンシブ画像切り替え imgにclass「js-image-switch」// responsive image switch class "js-image-switch" in img
jQuery(function($) {

	if ( $('.js-image-switch').length > 0 ) {

		var $elem = $('.js-image-switch');
		var sp = '_sp.';
		var pc = '_pc.';
		// 画像を切り替えるウィンドウサイズ // Window size to switch images
		var replaceWidth = 768;

		function imageSwitch() {
			var windowWidth = parseInt($(window).width());
			$elem.each(function() {
				var $this = $(this);
				if(windowWidth >= replaceWidth) {
				$this.attr('src', $this.attr('src').replace(sp, pc));
				} else {
					$this.attr('src', $this.attr('src').replace(pc, sp));
				}
			});
		}
		imageSwitch();

		var resizeTimer;
		$(window).on('resize', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function() {
				imageSwitch();
			}, 200);
		});
	}
});


// アコーディオンの起動 // Activate the accordion
jQuery(function($) {


	if ( $('dl.accordion dt').length > 0 ) {

		$("dl.accordion dt").click(function(){
			$(this).next("dd").slideToggle();
			$(this).toggleClass("open");
		});
	}
});

// ドロワーメニュー // Drawer menu
jQuery(function($) {
    if ($('#toggle').length > 0) {
		$('#toggle').click(function () {
			$(this).toggleClass('toggle_active');
			$('#drawer_layer').fadeToggle();
			$('body').toggleClass('drawer_open');

			if ($(this).hasClass('toggle_active')) {
				$('nav').addClass('is_open');
				$('nav').removeClass('is_close');
			} else {
				$('nav').removeClass('is_open');
				$('nav').addClass('is_close');
			}
		});

		$('#drawer_layer').click(function () {
			$(this).fadeOut();
			$('#toggle').removeClass('toggle_active');
			$('body').removeClass('drawer_open');
			$('nav').removeClass('is_open');
			$('nav').addClass('is_close');
		});

		// エリア内リンク用 // For links within an area
		$('nav a').on('click', function(){
			// if (window.innerWidth <= 768) {
			if ($('#toggle:visible').length > 0) {
				$('#toggle').click();
			}
		});
	}

});


// facebookプラグインリサイズ処理 // facebook plugin resizing process
jQuery(function($) {

	if ( $('#pageplugin').length > 0 ) {

		var windowWidth = $(window).width();
		var htmlStr = $('#pageplugin').html();
		var timer = null;
		$(window).on('resize',function() {
			var resizedWidth = $(window).width();
			if(windowWidth != resizedWidth && resizedWidth < 500) {
				clearTimeout(timer);
				timer = setTimeout(function() {
					$('#pageplugin').html(htmlStr);
					window.FB.XFBML.parse();
			   		//window.FB.XFBML.parse()で再レンダリングします。// re-render with window.FB.XFBML.parse(); window.FB.XFBML.parse()
					var windowWidth = $(window).width();
				}, 500);
			}
		});
	}
});


const textSwiper = new Swiper('.c-textSlide__slide', {
  slidesPerView: 'auto',   // 複数表示
  spaceBetween: 20,
    loop: true,              // 無限ループ
    speed: 5000,             // 移動速度（ms）
    autoplay: {
      delay: 0,              // 待機時間なし
      disableOnInteraction: false,
    }
});

const textSwiperReverse = new Swiper('.c-textSlide__slide--reverse', {
  slidesPerView: 'auto',   // 複数表示
	spaceBetween: 20,
	pauseOnMouseEnter: false,
	loop: true,              // 無限ループ
	speed: 5000,             // 移動速度（ms）
	autoplay: {
		delay: 0,              // 待機時間なし
		disableOnInteraction: false,
		reverseDirection: true,
  }
});

const companySwiper = new Swiper('.p-aboutCompany__slide', {
  slidesPerView: 'auto',   // 複数表示
  spaceBetween: 0,
  loop: true,              // 無限ループ
  speed: 8000,             // 移動速度（ms）
  autoplay: {
    delay: 0,              // 待機時間なし
    disableOnInteraction: false,
  }
});

jQuery(function($) {
  const $targets = $('.typing');

  $targets.each(function() {
    const $target = $(this);
    const html = $target.html(); // ← HTMLごと取得（<br>を保持）
    $target.html('').css('visibility', 'visible');
    let animated = false;

    $(window).on('scroll', function() {
      const elemTop = $target.offset().top;
      const scroll = $(window).scrollTop();
      const windowHeight = $(window).height();

      if (!animated && scroll > elemTop - windowHeight + 100) {
        animated = true;

        // 一文字ずつHTMLを描画する
        let i = 0;
        const chars = html.match(/(<[^>]+>|[^<])/g);
        // ↑ <br>などのタグと文字を区別して分割
        const interval = setInterval(() => {
          $target.append(chars[i]);
          i++;
          if (i >= chars.length) clearInterval(interval);
        }, 80);
      }
    });
  });
});
